import { Text } from '@/components/shared/Text/Text';

interface QuizResultsProps {
  quiz: object | undefined;
}

const QuizResults = ({ quiz }: QuizResultsProps) => {
  return (
    <div className="bg-white-100 p-6 rounded-[16px] align-center divide-y divide-neutral-10 max-w-screen-md  animation-appear">
      <div className="grid gap-4">
        {quiz && (
          <div className="col-span-2">
            {Object.entries(quiz).map(([question, answer], index) => (
              <div key={index} className="mb-4">
                <Text.Normal>
                  <strong>{question}:</strong> {answer}
                </Text.Normal>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizResults;
